import {Async, AsyncResult, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {SsoResponseDto} from 'Users/api';

export enum LegacyFormActionType {
  LOAD_LEGACY_FORMS = 'legacyForm/LOAD_LEGACY_FORMS',
  CHANGE_LEGACY_FORMS = 'legacyForm/CHANGE_LEGACY_FORMS',
}

export const getLegacyForms = (encryptedIdentifier: string, userId: string, isNewYork: boolean) =>
  createAction(LegacyFormActionType.LOAD_LEGACY_FORMS, {encryptedIdentifier, userId, isNewYork});
export const changeLegacyForms = (
  legacyForm: Async<AsyncResult<SsoResponseDto>>,
  interactiveLegacyForm: Async<AsyncResult<SsoResponseDto>>,
  legacyBulletin: Async<AsyncResult<SsoResponseDto>>
) => createAction(LegacyFormActionType.CHANGE_LEGACY_FORMS, {legacyForm, interactiveLegacyForm, legacyBulletin});

type LegacyFormAction = ReturnType<typeof changeLegacyForms>;

const DEFAULT_STATE: LegacyFormState = {
  legacyForm: new Empty(),
  interactiveLegacyForm: new Empty(),
  legacyBulletin: new Empty(),
};

type LegacyFormState = {
  legacyForm: Async<AsyncResult<SsoResponseDto>>;
  interactiveLegacyForm: Async<AsyncResult<SsoResponseDto>>;
  legacyBulletin: Async<AsyncResult<SsoResponseDto>>;
};

export default (state: LegacyFormState = DEFAULT_STATE, action: LegacyFormAction): LegacyFormState => {
  switch (action.type) {
    case LegacyFormActionType.CHANGE_LEGACY_FORMS:
      return {
        ...state,
        legacyForm: action.payload.legacyForm,
        interactiveLegacyForm: action.payload.interactiveLegacyForm,
        legacyBulletin: action.payload.legacyBulletin,
      };
    default:
      return state;
  }
};
